import React from 'react';

const NoZoneImage = () => (
  <div className="ui segment zone">
    <div className="plan">
      <div className="ui message">
        <div className="ui header">Aucune image</div>
        <div className="content">
          <p>
            Veuillez ajouter une image de fond pour pouvoir positionner des
            postes.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default NoZoneImage;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/zones/plan/components/NoZoneImage.js